module.exports = __webpack_public_path__ + "img/pdf.c277b8cb.svg";